<div class="lg:block hidden desktop-view-navbar">
    <app-navbar></app-navbar>
</div>
